const ActivityStateMap = {
  COMING_SOON: {
    text: 'comingSoon',
    iconClassName: 'icon-magic-fill',
    tip: 'comingSoonTip',
  },
  ON_GOING: {
    text: 'ongoing',
    iconClassName: 'icon-clock-fill',
    tip: 'ongoingTip',
  },
  ACCEPTED: {
    text: 'accepted',
    iconClassName: 'icon-success-fill',
    tip: 'acceptedTip',
  },
  EXPIRED: {
    text: 'expired',
    iconClassName: 'icon-calendar-fill',
    tip: 'expiredTip',
  },
};

export default function useActivityStatus(state?: string): { text: string; iconClassName: string; tip: string } {
  return ActivityStateMap[state as keyof typeof ActivityStateMap] ?? ActivityStateMap.COMING_SOON;
}
